//Prachi Tawde : 03-07-2023 : BT-108578 -  Breeze - Quick user switch - Start
import { memo, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../components';
import { handleModal } from '../../redux/actions/modals';
import DeleteProfileConfirmationModal from './DeleteProfileConfirmationModal';
import SuccessModal from './SuccessModal';
import { LOCAL_STORAGE_KEYS } from '../../utils/global_variables';

const ProfileSettingsModal = ({ userDetails, setUserDetails, setIsLocalStorageChanged, handleUseAnotherAccount }) => {
    const dispatch = useDispatch();

    const modals = useSelector(state => state?.modals?.modals);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const [selectedUser, setSelectedUser] = useState({});

    const onHide = () => {
        dispatch(handleModal([{ "PROFILE_SETTINGS_MODAL": false }]));
    };

    const handleDeleteSuccessMessage = () => {
        dispatch(handleModal([{ 'USER_DELETE_SUCCESS_MODAL': true }]));
        setTimeout(() => {
            dispatch(handleModal([{ 'USER_DELETE_SUCCESS_MODAL': false }]));
        }, 1000);
    };

    const handleDeleteUser = (user) => {
        if (userDetails) {
            setSelectedUser(user);
            dispatch(handleModal([{ 'DELETE_PROFILE_CONFIRMATION_MODAL': true }]));
        }
    };

    const onDeleteProfileConfirmation = () => {
        if (selectedUser) {
            localStorage.removeItem(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${selectedUser?.userId}`);
            setUserDetails(userDetails.filter((each) => each.userId !== selectedUser?.userId));
            setIsLocalStorageChanged(true);
            dispatch(handleModal([{ 'DELETE_PROFILE_CONFIRMATION_MODAL': false }, { 'PROFILE_SETTINGS_MODAL': true }]));
            handleDeleteSuccessMessage();
        }
    };


    return (
        <>
            <BzModal show={modals['PROFILE_SETTINGS_MODAL']} onHide={onHide} id="TopModal" role="dialog" aria-hidden="true" className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Profile Settings</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={onHide}>&nbsp;</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        {userDetails.map((each) => (
                            <Row key={each.userId} className='g-0 my-3'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='user-profile'>
                                        <div className='icon-16 icon-user icon-secondary'>&nbsp;</div>
                                    </div>
                                    <div className='ms-3'>
                                        <label className='font-medium font-size4 color-text' htmlFor={each?.userId}>{each?.userName}</label>
                                        <div className='font-regular font-size1 color-subtext'>User ID: <span className='font-regular color-text'>{each?.aliasId ? each?.aliasId : each?.userId}</span></div>
                                    </div>
                                </Col>
                                {userDetails.length >= 2 ?
                                    <Col md={2} className='d-flex justify-content-end align-items-center cursor-pointer'>
                                        {each?.userId !== objLoginSession?.data?.user_id ?
                                            <div className='justify-content-end icon-16 icon-delete icon-dark mx-2' onClick={handleDeleteUser.bind(this, each)}></div>
                                            :
                                            <div className='justify-content-end mx-2'>&nbsp;</div>}
                                    </Col>
                                    : null}
                            </Row>
                        ))}

                    </Container>
                </BzModalBody>
                <BzModalFooter className='p-3'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex align-items-center focus p-1'>
                                <div className='icon-20 icon-profile background-textual-link-withicon me-2' onClick={onHide}></div>
                                <div className='font-medium font-size4 color-textual-link-withicon cursor-pointer' onClick={handleUseAnotherAccount}>Add another account</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
            <DeleteProfileConfirmationModal user={selectedUser} onDeleteProfileConfirmation={onDeleteProfileConfirmation} />
            <SuccessModal />
        </>

    );
};

export default memo(ProfileSettingsModal);
